import React from 'react';
import './transcription.scss';

const Transcription = () => {
  return (
    <div className="transcription_container" style={{ '--time-scroll': '10s' }}>
      <p className="transcription_text"></p>
    </div>
  );
};

export default Transcription;
